<template>
  <div>
    <v-alert type="warning" v-if="error"
      >An API error occurred while downloading this data</v-alert
    >
    <v-card flat :loading="loading" class="blueCard mb-4"
      ><div class="d-flex flex-row align-center pa-1">
        <div style="width: 100px">
          <v-img
            :src="imgPath + 'bottle_colors.svg'"
            width="80"
            contain
            class="mr-4"
          />
        </div>
        <div class="title">Ophthalmic Medication Cap Colors</div>
      </div></v-card
    >
    <v-data-table
      v-if="json"
      :headers="$vuetify.breakpoint.smAndUp ? headers : oneHeader"
      :items="json"
      dense
      items-per-page="20"
      :loading="loading"
      hide-default-footer
      :hide-default-header="!$vuetify.breakpoint.smAndUp"
      class="aTable"
      :class="{ daTable: !$vuetify.breakpoint.smAndUp }"
    >
      <template v-slot:item.color="{ item }">
        <div style="text-align: center" class="width100p">
          <v-img
            :src="`${imgPath}${item.image}.svg`"
            contain
            max-width="75"
            class="mx-auto"
          />
          <div class="caption align-center">{{ item.color }}</div>
        </div>
      </template>
      <template v-slot:item.category="{ item }">
        <vue-markdown class="mdContent">{{
          item.category
        }}</vue-markdown></template
      >
      <template v-slot:item.examples="{ item }">
        <div v-for="(row, i) in item.examples" :key="item.color + i">
          <vue-markdown>{{ row }}</vue-markdown>
        </div>
      </template>

      <template v-slot:item.row="{ item }">
        <div class="width100p text-left">
          <div
            class="d-flex flex-row align-center pa-2"
            style="background-color: #e2f5ff"
          >
            <div style="text-align: center; min-width: 90px; height: 90px">
              <div style="text-align: center; min-width: 70px; height: 70px">
                <v-img
                  :src="`${imgPath}${item.image}.svg`"
                  contain
                  max-width="75"
                  class="mx-auto"
                />
              </div>
            </div>
            <div class="ml-2">
              <div>{{ item.color }} Cap</div>

              <vue-markdown class="mdContent font-weight-medium">{{
                item.category
              }}</vue-markdown>
            </div>
          </div>
          <div style="border: 1px solid #e2f5ff" class="mb-2 pa-2">
            <div class="overline align-left">Examples:</div>
            <div v-for="(row, i) in item.examples" :key="item.color + i">
              <vue-markdown>{{ row }}</vue-markdown>
            </div>
          </div>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import VueMarkdown from "@adapttive/vue-markdown";
import GetJsonMixin from "@/assets/js/GetJsonMixin";

export default {
  name: "CapColors",
  components: {
    VueMarkdown,
    // Page
  },
  mixins: [GetJsonMixin],
  props: {},
  data: function () {
    return {
      json: null,
      error: false,
      loading: false,
      imgPath: "https://www.eyedock.com/images/meds/",
      headers: [
        { value: "color", text: "Color" },
        { value: "category", text: "Category" },
        { value: "examples", text: "Examples" },
      ],
      oneHeader: [{ value: "row", text: "Row" }],
    };
  },
  methods: {},
  computed: {},
  mounted() {
    this.getJSON("capColors", "json"); // in the mixin
  },
};
</script>

<style scoped>
.aTable >>> tr:hover {
  background-color: transparent !important;
}

.daTable >>> td {
  display: block;
  box-sizing: border-box;
  clear: both;
}
</style>
